import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia";
import { LinkButton } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type EmploymentVerificationGetStartedModalProps = {
  isStarting: boolean;
  isMiniBrowserOpen: boolean;
  isSkipping?: boolean;
  onClose: () => void;
  onSkipClick: () => void;
  onConfirmStart: () => void;
};

export const EmploymentVerificationGetStartedModal = ({
  isStarting,
  isMiniBrowserOpen,
  isSkipping = false,
  onClose,
  onSkipClick,
  onConfirmStart,
}: EmploymentVerificationGetStartedModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen testID="konfir-get-started-modal">
      <Dialog aria-label="konfir-get-started-dialogue">
        <DialogHeader onClose={onClose}>
          {t("Get started with Konfir verification service")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              {t(
                "A new window will open, directing you to an external site with our partner, Konfir, to help us verify your employment."
              )}
            </Text>
            <Text style="global/body-primary">
              {t(
                "Please return to this page after completing the employment verification process."
              )}
            </Text>
            <Text style="global/body-primary">
              <Trans
                components={{
                  skip: (
                    <LinkButton
                      testID="konfir-get-started-skip-link"
                      linkStyle="monochrome"
                      textStyle="global/body-primary"
                      onPress={onSkipClick}
                      isDisabled={isSkipping}
                    />
                  ),
                }}
              >
                {
                  "<skip>Click here</skip> if you would prefer to skip this step."
                }
              </Trans>
            </Text>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <PrimaryButton
            testID="konfir-get-started-confirm"
            onPress={onConfirmStart}
            isDisabled={isStarting || isMiniBrowserOpen || isSkipping}
            isLoading={isStarting}
            rightIcon="open_in_new"
          >
            {t("Start verification")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
};
